module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel5-en-5a6f7eb1ae9313618deeff7b2d3a2443.png";